import { render, staticRenderFns } from "./FacebookAccount.vue?vue&type=template&id=6672679c&"
import script from "./FacebookAccount.vue?vue&type=script&lang=js&"
export * from "./FacebookAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports